import { IFileInFolderInfo } from 'isogd-file-rest';

class FileInFnController {
    file: IFileInFolderInfo;
    extension: string;
    name: string;
    size: string;
    date: Date;
    $onInit() {
        this.extension = this.file.fileName.split('.').pop().toLowerCase();
        this.name = this.file.fileName;
        let sizeKB = this.file.fileSize / 1024.0;
        let isKB = (sizeKB < 1024.0) ? true : false;
        this.size = (isKB) ? sizeKB.toFixed(1).toString() + ' Кб' : (sizeKB / 1024.0).toFixed(2).toString() + ' Мб';
        this.date = new Date(this.file.dateLastModified);
    }

    open(id: string) {
        let url = `isogd-api/v2/files/view/${id}`;
        window.open(url, '_blank');
    }
}

export const fileInFn: angular.IComponentOptions = {
    controller: FileInFnController,
    template: require('./fileInFn.html'),
    bindings: {
        file: '<'
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/file/fileInFn.ts